import React from 'react'

import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { FormikErrors } from 'formik'

import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { CompetencyGroupSelector } from 'modules/competencies/components/CompetencyGroupSelector'
import { type WizardData } from 'modules/competencies/pages/CompetenciesList/NewCompetencyWizard/types'

type Props = WizardStepRenderParams<WizardData> & {
  errors: FormikErrors<WizardData>
}

export const BasicInformationStep: React.FC<Props> = ({ data, onDataChanged, errors }) => {
  // Allow to proceed to the levels step even if it had levels with errors
  useOnNext(() => Promise.resolve())

  return (
    <Box gap="s16" paddingRight="s6">
      <Text.Header2 color="grey1000">
        {i18n.t('competencies_v3.new_competency_wizard.basic_information_step.details')}
      </Text.Header2>
      <TextField
        label={i18n.t('competencies_v3.new_competency_wizard.basic_information_step.name_input')}
        value={data.name}
        error={errors.name}
        onChange={(value) => onDataChanged({ ...data, name: value })}
        mandatory
      />
      <CompetencyGroupSelector
        value={data.competencyGroupId}
        error={errors.competencyGroupId}
        onChange={(groupId) => onDataChanged({ ...data, competencyGroupId: groupId ?? undefined })}
      />
      <TextArea
        label={i18n.t(
          'competencies_v3.new_competency_wizard.basic_information_step.description_input'
        )}
        value={data.description}
        error={errors.description}
        minRows={4}
        maxHeight="s240"
        onChange={(value) => onDataChanged({ ...data, description: value })}
      />
    </Box>
  )
}
